import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { tabFilterState } from "../../common/types/SliceTypes";
import { RootState } from "../store";
import { AXIOS } from "../../api/axios";
import {
  FilterEntity,
  FilterFieldChoiceEntity,
  phraseEntity,
} from "../../common/types/EntityTypes";
import { TAB_FILTER_HEADERS } from "../../common/constants";
import _ from "lodash";

const initialState: tabFilterState = {
  selectedTabFilterInfo: {} as FilterEntity,
  selectedFilterChoices: [],
  isTabFilterDirty: false as boolean,
  filterErrorMessage: "",
  filterDialogState: "",
  readOnlyFilterId: "",
  sharedFilterState: {
    id: "",
    userExternalId: "",
    filterExternalId: "",
    enabled: false,
    emailIds: [],
  },
  filterChoiceToBeEdited: -1,
  arrayOfSelectedAllFields:[],
};

export const tabFilterSlice = createSlice({
  name: "tabFilter",
  initialState: initialState,
  reducers: {
    setSelectedFilterSharedState: (state, value) => {
      return {
        ...state,
        sharedFilterState: value.payload,
      };
    },
    setSelectedFilterSharedEnabledState: (state, value) => {
      let filteredState = state.sharedFilterState;
      if (filteredState) filteredState.enabled = true;
      return {
        ...state,
        sharedFilterState: filteredState,
      };
    },
    setSelectedFilterSharedDisabledState: (state, value) => {
      let filteredState = state.sharedFilterState;
      if (filteredState) filteredState.enabled = false;
      return {
        ...state,
        sharedFilterState: filteredState,
      };
    },
    setFilterChoiceToBeEdited: (state, value) => {
      return {
        ...state,
        filterChoiceToBeEdited: value?.payload,
      };
    },
    setIsTabFilterDirty: (state, value) => {
      return {
        ...state,
        isTabFilterDirty: value.payload,
      };
    },
    setFilterDialogState: (state, value) => {
      return {
        ...state,
        filterDialogState: value.payload,
      };
    },
    setSelectedTabFilterInfo: (state, value) => {
      return {
        ...state,
        selectedTabFilterInfo: value.payload,
      };
    },
    setFilterErrorMessage: (state, value) => {
      return {
        ...state,
        filterErrorMessage: value.payload,
      };
    },
    setReadOnlyFilterId: (state, value) => {
      return {
        ...state,
        readOnlyFilterId: value.payload,
      };
    },
    initializeFilterChoices: (state, value) => {
      let filterChoices: FilterFieldChoiceEntity[] = [];
      TAB_FILTER_HEADERS.forEach((field) => {
        filterChoices.push({
          fieldCode: field.fieldCode,
          has: [],
          hasNot: [],
          fieldName: field.name,
        });
      });
      return {
        ...state,
        selectedFilterChoices: filterChoices,
      };
    },
    //new Reducers;
    initializeFilterChoicesv2: (state, value) => {
      let filterChoices: any[] = [];
      TAB_FILTER_HEADERS.forEach((field) => {
        filterChoices.push({
          fieldCode: field.fieldCode,
          fieldName: field.name,
          historyList: [],
          selectedFields: [],
          has: [],
          hasNot: [],
        });
      });
      return {
        ...state,
        selectedFilterChoices: filterChoices,
      };
    },
    setHistoryListForActiveFieldr: (state, value) => {
      const {
        formattedPhrases,
        fieldCode: sfieldCode,
        phrasesFromDb,
      } = value.payload;
      let selectedFields: any = [];
      let fieldHasSelectedPhrases =
        Object.keys(phrasesFromDb).includes(sfieldCode);
      if (fieldHasSelectedPhrases) {
        let selectedPhrasesForField = phrasesFromDb?.[sfieldCode]?.[0]?.has;
        selectedPhrasesForField.forEach(
          ({ text, externalId }: { text: string; externalId: string }) => {
            let index = formattedPhrases.findIndex(
              ({ text: stext }: { text: string }) => text == stext
            );
            if (index !== -1) {
              formattedPhrases[index] = {
                ...formattedPhrases[index],
                isSelected: true,
                index,
                externalId,
              };
              selectedFields.push({
                ...formattedPhrases[index],
                index,
                externalId,
              });
            }
          }
        );
      }
      return {
        ...state,
        selectedFilterChoices: state.selectedFilterChoices.map((field) => {
          if (field.fieldCode === sfieldCode) {
            let selectedFieldToUpdate = { ...field };
            if (selectedFieldToUpdate?.historyList) {
              selectedFieldToUpdate.historyList = formattedPhrases;
              selectedFieldToUpdate.selectedFields = selectedFields;
              // if (selectedFieldToUpdate?.historyList.length === 0) {
              //   selectedFieldToUpdate.historyList = formattedPhrases;
              //   selectedFieldToUpdate.selectedFields = selectedFields;
              // }
              return selectedFieldToUpdate;
            }
          }
          return field;
        }),
      };
    },
    sortFilterChoicesv2:(state,value)=>{
      const {sfieldCode,sortType}= value.payload
      let sortedSelectedFilterChoices = state.selectedFilterChoices.map((item:any)=>{
        if(item.fieldCode !== sfieldCode){ return item};
        let tempHistroyList = [...item.historyList]
        tempHistroyList = tempHistroyList.sort((a, b) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime()) 
        return {...item,historyList:tempHistroyList}
      })
      return{
        ...state,
        selectedFilterChoices:sortedSelectedFilterChoices
      }
    },
    toggleCheckForField: (state, value) => {
      const { key: sfieldCode, index: sindex } = value.payload;
      return {
        ...state,
        selectedFilterChoices: state.selectedFilterChoices.map((field) => {
          if (field.fieldCode !== sfieldCode) return field;

          const updatedHistoryList = [...(field.historyList ?? [])];
          let updateSelectedList = [...(field.selectedFields ?? [])];

          if (updatedHistoryList[sindex]) {
            updatedHistoryList[sindex] = {
              ...updatedHistoryList[sindex],
              isSelected: !updatedHistoryList[sindex].isSelected,
            };
          }

          let preSelectedPhraseIndex = updateSelectedList.findIndex(
            (each) => each.index === sindex
          );
          if (updatedHistoryList?.[sindex]?.isSelected) {
            if (preSelectedPhraseIndex !== -1) {
              const updatePreSelectedPhrase = {
                ...updateSelectedList[preSelectedPhraseIndex],
                isSelected: true,
                action: "UPDATE",
              };
              updateSelectedList[preSelectedPhraseIndex] =
                updatePreSelectedPhrase;
            } else {
              updateSelectedList.push(updatedHistoryList[sindex]);
            }
          } else {
            if (updateSelectedList[preSelectedPhraseIndex]?.externalId) {
              const updatePreSelectedPhrase = {
                ...updateSelectedList[preSelectedPhraseIndex],
                isSelected: false,
                action: "DELETE",
              };
              updateSelectedList[preSelectedPhraseIndex] =
                updatePreSelectedPhrase;
            } else {
              updateSelectedList = updateSelectedList.filter(
                ({ index }) => index !== sindex
              );
            }
          }
          return {
            ...field,
            historyList: updatedHistoryList,
            selectedFields: updateSelectedList,
          };
        }),
      };
    },
    clearSelectedFields: (state, value) => {
      const { uncheckedHistroyList, sfieldCode, updatedSelectedList } =
        value.payload;
      return {
        ...state,
        selectedFilterChoices: state.selectedFilterChoices.map((field) => {
          if (field.fieldCode === sfieldCode) {
            let selectedFieldToUpdate = { ...field };
            if (
              selectedFieldToUpdate?.historyList &&
              selectedFieldToUpdate?.selectedFields
            ) {
              selectedFieldToUpdate.historyList = uncheckedHistroyList;
              selectedFieldToUpdate.selectedFields = updatedSelectedList;
            }
            return selectedFieldToUpdate;
          }
          return field;
        }),
      };
    },
    clearAllSelections: (state, value) => {
      return {
        ...state,
        selectedFilterChoices: state.selectedFilterChoices.map((field) => {
          let selectedFieldToUpdate = { ...field };
          if (
            selectedFieldToUpdate?.historyList &&
            selectedFieldToUpdate?.selectedFields
          ) {
            selectedFieldToUpdate.historyList =
              selectedFieldToUpdate.historyList.map((each) => {
                return { ...each, isSelected: false };
              });
            selectedFieldToUpdate.selectedFields =
              selectedFieldToUpdate.selectedFields
                .filter((each) => each.externalId)
                .map((each) => {
                  return { ...each, isSelected: false, action: "DELETE" };
                });
          }
          return selectedFieldToUpdate;
        }),
      };
    },
    addPhraseToSelection: (state, value) => {
      const { activeFieldCode, phrase } = value.payload;
      let errorMessage = '';
      const updatedChoices = state.selectedFilterChoices.map((field) => {
      if (field.fieldCode !== activeFieldCode) return field;
        let selectedFieldToUpdate = { ...field };
        if (selectedFieldToUpdate?.selectedFields && selectedFieldToUpdate.historyList) {
          let NewPhrase: phraseEntity = { text: phrase, isSelected: true };
          let NewPhraseExists =
            selectedFieldToUpdate.selectedFields.findIndex(
              (phrase) => phrase.text === NewPhrase.text
            );
          if (NewPhraseExists === -1) {
              selectedFieldToUpdate.historyList = selectedFieldToUpdate.historyList.map((each: phraseEntity) => {
                if(each?.text !== NewPhrase.text.trim()) {return each}
                else{
                  let newEach = {...each}
                  newEach.isSelected = true
                  NewPhrase = newEach
                  return newEach;
                }
            });
            selectedFieldToUpdate.selectedFields = [
              ...selectedFieldToUpdate.selectedFields,
              NewPhrase,
            ];
          } else {
            errorMessage = 'The Phrase already exists';
          }
        }
      return selectedFieldToUpdate;})
      return {
        ...state,
        selectedFilterChoices:updatedChoices,
        filterErrorMessage:errorMessage
      };
    },
    setSelectedAllFieldsArray :(state,value) => {
      const { activeFieldCode } = value.payload;
      let modifiedSelectedAllFieldsArray = state.arrayOfSelectedAllFields || [];
      modifiedSelectedAllFieldsArray = [...modifiedSelectedAllFieldsArray, activeFieldCode];
      return {
        ...state,
        arrayOfSelectedAllFields:modifiedSelectedAllFieldsArray,  
      }
    },
    setUnSelectedAllFieldsArray : (state,value) =>{
        const { activeFieldCode } = value.payload;
        let modifiedSelectedAllFieldsArray = state.arrayOfSelectedAllFields || [];
        if(activeFieldCode === 0){
        modifiedSelectedAllFieldsArray = []
        } else{
          if(modifiedSelectedAllFieldsArray?.includes(activeFieldCode)){
              modifiedSelectedAllFieldsArray = modifiedSelectedAllFieldsArray?.filter((each) => each !== activeFieldCode);
          }
        } 
        return {
        ...state,
        arrayOfSelectedAllFields:modifiedSelectedAllFieldsArray,  
      }
    },
    setUserSelectedFilterChoices: (state, value) => {
      return {
        ...state,
        selectedFilterChoices: state.selectedFilterChoices?.map((field) => {
          const userChoices = value.payload[field.fieldCode]?.[0];
          if (userChoices?.fieldCode) {
            const f = { ...field };
            if (userChoices?.has) {
              f.has = userChoices?.has;
            }
            if (userChoices?.hasNot) {
              f.hasNot = userChoices?.hasNot;
            }
            return f;
          }
          return field;
        }),
      };
    },
    setSelectedFilterChoices: (state, value) => {
      return {
        ...state,
        isTabFilterDirty: true,
        selectedFilterChoices: state.selectedFilterChoices.map((field) => {
          if (field.fieldCode === value.payload?.fieldCode) {
            const f = { ...field };
            if (value.payload?.has) {
              f.has = [...field.has, value.payload?.has];
            }
            if (value.payload?.hasNot) {
              f.hasNot = [...field.hasNot, value.payload?.hasNot];
            }
            return f;
          }
          return field;
        }),
      };
    },
    setEditableFilterChoice: (state, value) => {
      return {
        ...state,
        isTabFilterDirty: true,
        selectedFilterChoices: state.selectedFilterChoices.map((field) => {
          if (field.fieldCode === value.payload?.fieldCode) {
            const f = { ...field };
            if (value.payload?.hasOption == "has") {
              // if (value.payload?.externalId) {
              f.has = field.has.map((g) => {
                const el = { ...g };
                if (el.text === value.payload.text)
                  el.isEditable = value.payload?.isEditable;
                return el;
              });
              // } else {
              //   f.has = field.has.filter((el) => {
              //     if (el.text !== value.payload.text) return el;
              //   });
              // }
            }
            if (value.payload?.hasOption == "hasNot") {
              // if (value.payload?.externalId) {
              f.hasNot = field.hasNot.map((g) => {
                const el = { ...g };
                if (el.text === value.payload.text)
                  el.isEditable = value.payload?.isEditable;
                return el;
              });
              // } else {
              //   f.hasNot = field.hasNot.filter((el) => {
              //     if (el.text !== value.payload.text) return el;
              //   });
              // }
            }
            return f;
          }
          return field;
        }),
      };
    },
    setEditedFilterChoice: (state, value) => {
      return {
        ...state,
        isTabFilterDirty: true,
        selectedFilterChoices: state.selectedFilterChoices.map((field) => {
          if (field.fieldCode === value.payload?.fieldCode) {
            const f = { ...field };
            if (value.payload?.hasOption == "has") {
              // if (value.payload?.externalId) {
              f.has = field.has.map((g) => {
                const el = { ...g };
                if (el.text === value.payload.text) {
                  el.text = value.payload.editExactPhrase;
                  el.isEditable = value.payload?.isEditable;
                  el.action = "UPDATE";
                }
                return el;
              });
              // } else {
              //   f.has = field.has.filter((el) => {
              //     if (el.text !== value.payload.text) return el;
              //   });
              // }
            }
            if (value.payload?.hasOption == "hasNot") {
              // if (value.payload?.externalId) {
              f.hasNot = field.hasNot.map((g) => {
                const el = { ...g };
                if (el.text === value.payload.text) {
                  el.text = value.payload.editExactPhrase;
                  el.isEditable = value.payload?.isEditable;
                  el.action = "UPDATE";
                }
                return el;
              });
              // } else {
              //   f.hasNot = field.hasNot.filter((el) => {
              //     if (el.text !== value.payload.text) return el;
              //   });
              // }
            }
            return f;
          }
          return field;
        }),
      };
    },
    removeFilterChoices: (state, value) => {
      return {
        ...state,
        isTabFilterDirty: true,
        selectedFilterChoices: state.selectedFilterChoices.map((field) => {
          if (field.fieldCode === value.payload?.fieldCode) {
            const f = { ...field };
            if (value.payload?.hasOption == "has") {
              if (value.payload?.externalId) {
                f.has = field.has.map((g) => {
                  const el = { ...g };
                  if (el.text === value.payload.text) el.action = "DELETE";
                  return el;
                });
              } else {
                f.has = field.has.filter((el) => {
                  if (el.text !== value.payload.text) return el;
                });
              }
            }
            if (value.payload?.hasOption == "hasNot") {
              if (value.payload?.externalId) {
                f.hasNot = field.hasNot.map((g) => {
                  const el = { ...g };
                  if (el.text === value.payload.text) el.action = "DELETE";
                  return el;
                });
              } else {
                f.hasNot = field.hasNot.filter((el) => {
                  if (el.text !== value.payload.text) return el;
                });
              }
            }
            return f;
          }
          return field;
        }),
      };
    },
    removeAllFilterChoices: (state, value) => {
      return {
        ...state,
        isTabFilterDirty: true,
        selectedFilterChoices: state.selectedFilterChoices.map((data) => {
          let existingData = { ...data };
          if (data.fieldCode === value.payload.fieldCode) {
            return {
              fieldCode: data.fieldCode,
              has:
                existingData.has
                  ?.map((e) => {
                    const g = { ...e };
                    g.action = "DELETE";
                    return g;
                  })
                  .filter((e) => e?.externalId) || [],
              hasNot:
                existingData.hasNot
                  ?.map((e) => {
                    const g = { ...e };
                    g.action = "DELETE";
                    return g;
                  })
                  .filter((e) => e?.externalId) || [],
            };
          } else {
            return existingData;
          }
        }),
      };
    },
  },
});

export const {
  setIsTabFilterDirty,
  setSelectedTabFilterInfo,
  setSelectedFilterChoices,
  initializeFilterChoices,
  //new Reducers
  initializeFilterChoicesv2,
  setHistoryListForActiveFieldr,
  sortFilterChoicesv2,
  toggleCheckForField,
  clearSelectedFields,
  clearAllSelections,
  addPhraseToSelection,
  setSelectedAllFieldsArray,
  setUnSelectedAllFieldsArray,
  //
  setUserSelectedFilterChoices,
  setEditableFilterChoice,
  setEditedFilterChoice,
  removeFilterChoices,
  removeAllFilterChoices,
  setFilterErrorMessage,
  setFilterDialogState,
  setReadOnlyFilterId,
  setSelectedFilterSharedState,
  setFilterChoiceToBeEdited,
  setSelectedFilterSharedEnabledState,
  setSelectedFilterSharedDisabledState,
} = tabFilterSlice.actions;

export const selectSelectedFilterSharedState = (state: RootState) =>
  state.tabFilter.sharedFilterState;

export const selectFilterChoiceToBeEdited = (state: RootState) =>
  state.tabFilter.filterChoiceToBeEdited;

export const selectSelectedFieldsAarray = (state: RootState) =>
  state.tabFilter.arrayOfSelectedAllFields;

export const selectSelectedFilterSharedIsEnabledState = (state: RootState) =>
  state.tabFilter.sharedFilterState
    ? state.tabFilter.sharedFilterState.enabled
    : false;

export const selectSelectedFilterSharedEmailState = (state: RootState) =>
  state.tabFilter.sharedFilterState
    ? state.tabFilter.sharedFilterState.emailIds
    : "";

export const selectSelectedTabFilterInfo = (state: RootState) =>
  state.tabFilter.selectedTabFilterInfo;

export const selectFilterDialogState = (state: RootState) =>
  state.tabFilter.filterDialogState;

export const selectSelectedFilterChoices = (state: RootState) =>
  state.tabFilter.selectedFilterChoices;

export const selectFilterErrorMessage = (state: RootState) =>
  state.tabFilter.filterErrorMessage;

export const selectIsTabFilterDirty = (state: RootState) =>
  state.tabFilter.isTabFilterDirty;

export const selectReadOnlyFilterId = (state: RootState) =>
  state.tabFilter.readOnlyFilterId;

export default tabFilterSlice.reducer;

export const getTabNames = createAsyncThunk(
  "client/alias/",
  async (tab: string, { getState }) => {
    const state = getState() as RootState;
    let url =
      process.env.REACT_APP_API_BASE_URL + "client/" + state.user.externalId;
    try {
      const response = await AXIOS.get(url);
      return response.data;
    } catch (err) {
      console.error(err);
    }
  }
);

export const getHistoryForField = createAsyncThunk(
  "values/field/",
  async (fieldCode: string, { getState }) => {
    const state = getState() as RootState;
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "values/field/" +
      fieldCode +
      "/" +
      state.user.externalId;
    try {
      const response = await AXIOS.get(url);
      return response.data;
    } catch (err) {
      console.error(err);
    }
  }
);

export const getExactPhrases = createAsyncThunk(
  "/filter/condition/",
  async (params: any, { getState }) => {
    const state = getState() as RootState;
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "/filter/condition/" +
      params.filterId +
      "/" +
      state.user.externalId;
    try {
      const response = await AXIOS.get(url);
      return response.data;
    } catch (err) {
      console.error(err);
    }
  }
);

export const bulkSaveFilterChoices = createAsyncThunk(
  "/filter/condition/",
  async (params: any, { getState }) => {
    const state = getState() as RootState;
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "/filter/condition/" +
      params.filterId +
      "/" +
      state.user.externalId;
    if (params.limitSearchLatest) {
      url = url + "?isLatestSearch=true";
    }
    try {
      const response = await AXIOS.post(url, [...params.filterChoices]);
      return response.data;
    } catch (err) {
      console.error(err);
    }
  }
);

export const setDisabledAccessForSharedFilter = createAsyncThunk(
  "/filter/get/hash/",
  async (params: any, { getState }) => {
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "/filter/share/disabled/" +
      params.filterId +
      "/" +
      params.userId;
    try {
      const response = await AXIOS.put(url);
      return response.data;
    } catch (err) {
      console.error(err);
      return undefined;
    }
  }
);

export const setEnabledAccessForSharedFilter = createAsyncThunk(
  "/filter/get/hash/",
  async (params: any, { getState }) => {
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "/filter/share/enabled/" +
      params.filterId +
      "/" +
      params.userId;
    try {
      const response = await AXIOS.put(url);
      return response.data;
    } catch (err) {
      return undefined;
    }
  }
);

export const getClientUserForHash = createAsyncThunk(
  "/filter/hash/",
  async (hash: string, { getState }) => {
    let url = process.env.REACT_APP_API_BASE_URL + "/filter/share/" + hash;
    let response;
    try {
      response = await AXIOS.get(url);
      return response.data;
    } catch (err) {
      return response?.data;
    }
  }
);

export const getHashForFilter = createAsyncThunk(
  "/filter/get/hash/",
  async (params: any, { getState }) => {
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "/filter/copy/" +
      params.filterId +
      "/" +
      params.userId;
    try {
      const response = await AXIOS.post(url);
      return response.data;
    } catch (err) {
      return undefined;
    }
  }
);

export const getSharedDetails = createAsyncThunk(
  "/filter/get/hash/",
  async (params: any, { getState }) => {
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "/filter/copy/" +
      params.filterId +
      "/" +
      params.userId;
    try {
      const response = await AXIOS.get(url);
      return response.data;
    } catch (err) {
      return undefined;
    }
  }
);

export const getHashAndShareForFilter = createAsyncThunk(
  "/filter/get/share/hash/",
  async (params: any, { getState }) => {
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "/filter/share/" +
      params.filterId +
      "/" +
      params.userId;
    try {
      const response = await AXIOS.post(url, params.emaildIds);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const getAllSharedDetails = createAsyncThunk(
  "/filter/get/user/hash/",
  async (params: any, { getState }) => {
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "/filter/share/" +
      params.filterId +
      "/" +
      params.userId;
    try {
      const response = await AXIOS.get(url);
      return response.data;
    } catch (err) {
      return null;
    }
  }
);

export const getFilterListForDocument = createAsyncThunk(
  '/filter/getFilterListForDocument',
  async(params:any,{getState})=>{
    const state = getState() as RootState;
    let url = process.env.REACT_APP_API_BASE_URL +
      "/filter/fields/" +
      params.documentId +
      "/" + state.user.externalId; 
    try {
      const response = await AXIOS.get(url);
      // console.log(response.data)
      return response.data;
    } catch (err) {
      return null;
    }
  }
  
)